import Injector from 'vue-inject';
import Debug from '@/util/debug';

const debug = Debug('service:GenericConfig');

export default class GenericConfigService {
  constructor(adApiService) {
    this.adApiService = adApiService;
    this.config = null;
    this.error = null;
  }

  loadConfigFromApi() {
    debug.info('loadConfigFromApi');
    return this.adApiService.getGenericConfig()
      .then(config => this.config = config)
      .then(config => {
        this.config = config;
        // TODO remove this logic as this config should be set from Dashboard
        if (this.config.goal_types && this.config.goal_types.local_offers) {
          if (!this.config.goal_types.local_offers.code_types) {
            this.config.goal_types.local_offers.code_types = ['none', 'one', 'unique'];
          }
          if (!this.config.goal_types.local_offers.redeems) {
            this.config.goal_types.local_offers.redeems = ['store', 'online', 'both'];
          }
        }
        return this.config;
      })
      .catch(err => {
        debug.error('error while loading from api: %o', err);
        this.error = err;
        throw err;
      });
  }

  getConfig() {
    debug.info('getConfig err: %o, config: %o', this.error, this.config);
    if (this.error !== null) {
      return new Promise((resolve, reject) => reject(this.error));
    } else if (this.config) {
      return new Promise(resolve => resolve(this.config));
    }

    return this.loadConfigFromApi();
  }
}

Injector.service('genericConfigService', ['adApiService'], GenericConfigService);



// WEBPACK FOOTER //
// ./src/services/GenericConfigService.js